import { SignIn } from "@clerk/react";
import { LogoMark } from "@/components/LogoMark";

export default function SignInPage() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 py-10 gap-6" data-no-translate data-testid="sign-in-page">
      <div className="flex items-center gap-3">
        <LogoMark className="w-10 h-10" />
        <p className="text-sm text-slate-600 max-w-xs">Reviewer sign-in for trusted translators and the site owner.</p>
      </div>
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
    </div>
  );
}
